










































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import ChannelList from '@/store/entities/channelmaintain'
import TantentSelectList from '@/store/entities/TantentSelect'
import Enums from '@/lib/enums'

class CreateConfigSettingRequest {
    token: string;
    AgentIp: string;
    AgentPassword: string;
    Note: string;
    IsLimit: string;
    TenantID: string;
    AgentAccount: string;
    IsAvailable: string;
    IsLoginInvalid: string;
    IsRevival:string;
    IsEffective: string;
    constructor() {
        this.TenantID = "0";
        this.IsLimit = "false";
        this.IsAvailable = "true";
        this.IsLoginInvalid = "false";
        this.IsRevival = 'true';
    }
}
@Component
export default class CreateConfigSetting extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    tionSetting: CreateConfigSettingRequest = new CreateConfigSettingRequest();
    //whetherIsLimitList = Enums.getEnum();
    whetherEffectiveList = Enums.WhetherEffective;
    isShow: boolean;
    TantentSelect:[];
    save() {
        (this.$refs.tionSettingForm as any).validate(async (valid: boolean) => {
            if (valid) {
                await this.$store.dispatch({
                    type: 'pddtoken/create',
                    data: this.tionSetting
                });
                (this.$refs.tionSettingForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input', false);
            }
        })
    }


   
    async getData() {
        this.TantentSelect =  await this.$store.dispatch({
            type: 'pddtoken/gettenantAll',
            data: {}
        })
        
    }

    async created() {

        this.getData()
    }
    cancel() {
        
        (this.$refs.tionSettingForm as any).resetFields();
        this.$emit('input', false);
    }
    visibleChange(value: boolean) {
        
        if (!value) {
            this.$emit('input', value);
        }
    }
    tionSettingRule = {
        
        //ConfigurationName: [{ required: true, message: this.L('FieldIsRequired', undefined, this.L('配置名称')), trigger: 'blur' }],
        //Keyword: [{ required: true, message: this.L('FieldIsRequired', undefined, this.L('关键字')), trigger: 'blur' }],
        //ConfigurationParameter: { required: true, message: 'FieldIsRequired', trigger: 'blur' },
    }
}
